export interface IInvoicePaymentRequest {
    InvoiceID: number;
    CreditCardID: number;
}

export class InvoicePaymentRequest implements IInvoicePaymentRequest {
    InvoiceID: number;
    CreditCardID: number;
}
